export const driverSchedulerTypes = {
  SET_CARDS_TASKS_GROUPS: "SET_CARDS_TASKS_GROUPS",
  SET_SELECTED_DATE: "SET_SELECTED_DATE",
  SET_SELECTED_CELL_ID: "SET_SELECTED_CELL_ID",
};
